// ================= FREE GIFT FINAL WORKING =================

const GIFT_VARIANT_ID = 47768785453230; 
let isUpdatingGift = false;

async function updateFreeGift() {
  if (isUpdatingGift) return;
  isUpdatingGift = true;

  try {
    const cart = await fetch('/cart.js').then(res => res.json());

    let totalQty = 0;

const promises = cart.items.map(async (item) => {
  if (item.properties && item.properties._freeGift) return;

  try {
    const product = await fetch(`/products/${item.handle}.js`).then(res => res.json());

    // ✅ check if product has "fragrance" tag
    if (product.tags && product.tags.includes('gift-product')) {
      totalQty += item.quantity;
    }

  } catch (e) {
    console.log('Product fetch error', e);
  }
});

await Promise.all(promises);

    const expectedGiftQty = Math.floor(totalQty / 2);
    const giftItem = cart.items.find(i => i.properties && i.properties._freeGift);

    // ADD GIFT
    if (expectedGiftQty > 0 && !giftItem) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: GIFT_VARIANT_ID,
      quantity: expectedGiftQty,
      properties: { _freeGift: true }
    })
  });

  refreshCartUI(); // 🔥 IMPORTANT
}

if (giftItem) {
  if (expectedGiftQty === 0) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: 0
      })
    });

    refreshCartUI(); // 🔥 IMPORTANT
  } else if (giftItem.quantity !== expectedGiftQty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: giftItem.key,
        quantity: expectedGiftQty
      })
    });

    refreshCartUI(); // 🔥 IMPORTANT
  }
}
    

  } catch (e) {
    console.log("Gift Error:", e);
  }

  isUpdatingGift = false;
}

function refreshCartUI() {
  // Drawer refresh (Ella / most themes)
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
        window.sharedFunctions.updateSidebarCart(cart);
      }
    });

  // Cart page refresh
  if (window.location.pathname === '/cart') {
    location.reload();
  }
}